export const samplingFrequencyInHz = [
  96000,
  88200,
  64000,
  48000,
  44100,
  32000,
  24000,
  22050,
  16000,
  12000,
  11025,
  8000,
];

export const PRED_SFB_MAX = [
  33, // 96000 Hz
  33, // 88200 Hz
  38, // 64000 Hz
  40, // 48000 Hz
  40, // 44100 Hz
  40, // 32000 Hz
  41, // 24000 Hz
  41, // 22050 Hz
  37, // 16000 Hz
  37, // 12000 Hz
  37, // 11025 Hz
  34, //  8000 Hz
];

export const num_swb_long_window = [
  41, // 96000 Hz
  41, // 88200 Hz
  47, // 64000 Hz
  49, // 48000 Hz
  49, // 44100 Hz
  51, // 32000 Hz
  47, // 24000 Hz
  47, // 22050 Hz
  43, // 16000 Hz
  43, // 12000 Hz
  43, // 11025 Hz
  40, //  8000 Hz
];

const swb_offset_long_window_88200_96000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  32,
  36,
  40,
  44,
  48,
  52,
  56,
  64,
  72,
  80,
  88,
  96,
  108,
  120,
  132,
  144,
  156,
  172,
  188,
  212,
  240,
  276,
  320,
  384,
  448,
  512,
  576,
  640,
  704,
  768,
  832,
  896,
  960,
  1024,
];

const swb_offset_long_window_64000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  32,
  36,
  40,
  44,
  48,
  52,
  56,
  64,
  72,
  80,
  88,
  100,
  112,
  124,
  140,
  156,
  172,
  192,
  216,
  240,
  268,
  304,
  344,
  384,
  424,
  464,
  504,
  544,
  584,
  624,
  664,
  704,
  744,
  784,
  824,
  864,
  904,
  944,
  984,
  1024,
];

const swb_offset_long_window_44100_48000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  32,
  36,
  40,
  48,
  56,
  64,
  72,
  80,
  88,
  96,
  108,
  120,
  132,
  144,
  160,
  176,
  196,
  216,
  240,
  264,
  292,
  320,
  352,
  384,
  416,
  448,
  480,
  512,
  544,
  576,
  608,
  640,
  672,
  704,
  736,
  768,
  800,
  832,
  864,
  896,
  928,
  1024,
];

const swb_offset_long_window_32000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  32,
  36,
  40,
  48,
  56,
  64,
  72,
  80,
  88,
  96,
  108,
  120,
  132,
  144,
  160,
  176,
  196,
  216,
  240,
  264,
  292,
  320,
  352,
  384,
  416,
  448,
  480,
  512,
  544,
  576,
  608,
  640,
  672,
  704,
  736,
  768,
  800,
  832,
  864,
  896,
  928,
  960,
  992,
  1024,
];

const swb_offset_long_window_22050_24000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  32,
  36,
  40,
  44,
  52,
  60,
  68,
  76,
  84,
  92,
  100,
  108,
  116,
  124,
  136,
  148,
  160,
  172,
  188,
  204,
  220,
  240,
  260,
  284,
  308,
  336,
  364,
  396,
  432,
  468,
  508,
  552,
  600,
  652,
  704,
  768,
  832,
  896,
  960,
  1024,
];

const swb_offset_long_window_11025_12000_16000 = [
  0,
  8,
  16,
  24,
  32,
  40,
  48,
  56,
  64,
  72,
  80,
  88,
  100,
  112,
  124,
  136,
  148,
  160,
  172,
  184,
  196,
  212,
  228,
  244,
  260,
  280,
  300,
  320,
  344,
  368,
  396,
  424,
  456,
  492,
  532,
  572,
  616,
  664,
  716,
  772,
  832,
  896,
  960,
  1024,
];

const swb_offset_long_window_8000 = [
  0,
  12,
  24,
  36,
  48,
  60,
  72,
  84,
  96,
  108,
  120,
  132,
  144,
  156,
  172,
  188,
  204,
  220,
  236,
  252,
  268,
  288,
  308,
  328,
  348,
  372,
  396,
  420,
  448,
  476,
  508,
  544,
  580,
  620,
  664,
  712,
  764,
  820,
  880,
  944,
  1024,
];

export const swb_offset_long_window = [
  swb_offset_long_window_88200_96000, // 96000 Hz
  swb_offset_long_window_88200_96000, // 88200 Hz
  swb_offset_long_window_64000, // 64000 Hz
  swb_offset_long_window_44100_48000, // 48000 Hz
  swb_offset_long_window_44100_48000, // 44100 Hz
  swb_offset_long_window_32000, // 32000 Hz
  swb_offset_long_window_22050_24000, // 24000 Hz
  swb_offset_long_window_22050_24000, // 22050 Hz
  swb_offset_long_window_11025_12000_16000, // 16000 Hz
  swb_offset_long_window_11025_12000_16000, // 12000 Hz
  swb_offset_long_window_11025_12000_16000, // 11025 Hz
  swb_offset_long_window_8000, //  8000 Hz
];

export const num_swb_short_window = [
  12, // 96000 Hz
  12, // 88200 Hz
  12, // 64000 Hz
  14, // 48000 Hz
  14, // 44100 Hz
  14, // 32000 Hz
  15, // 24000 Hz
  15, // 22050 Hz
  15, // 16000 Hz
  15, // 12000 Hz
  15, // 11025 Hz
  15, //  8000 Hz
];

const swb_offset_short_window_88200_96000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  32,
  40,
  48,
  64,
  92,
  128,
];

const swb_offset_short_window_64000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  32,
  40,
  48,
  64,
  92,
  128,
];

const swb_offset_short_window_32000_44100_48000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  28,
  36,
  44,
  56,
  68,
  80,
  96,
  112,
  128,
];

const swb_offset_short_window_22050_24000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  36,
  44,
  52,
  64,
  76,
  92,
  108,
  128,
];

const swb_offset_short_window_11025_12000_16000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  32,
  40,
  48,
  60,
  72,
  88,
  108,
  128,
];

const swb_offset_short_window_8000 = [
  0,
  4,
  8,
  12,
  16,
  20,
  24,
  28,
  36,
  44,
  52,
  60,
  72,
  88,
  108,
  128,
];

export const swb_offset_short_window = [
  swb_offset_short_window_88200_96000, // 96000 Hz
  swb_offset_short_window_88200_96000, // 88200 Hz
  swb_offset_short_window_64000, // 64000 Hz
  swb_offset_short_window_32000_44100_48000, // 48000 Hz
  swb_offset_short_window_32000_44100_48000, // 44100 Hz
  swb_offset_short_window_32000_44100_48000, // 32000 Hz
  swb_offset_short_window_22050_24000, // 24000 Hz
  swb_offset_short_window_22050_24000, // 22050 Hz
  swb_offset_short_window_11025_12000_16000, // 16000 Hz
  swb_offset_short_window_11025_12000_16000, // 12000 Hz
  swb_offset_short_window_11025_12000_16000, // 11025 Hz
  swb_offset_short_window_8000, //  8000 Hz
];



export const ID_SCE = 0x0;
export const ID_CPE = 0x1;
export const ID_CCE = 0x2;
export const ID_LFE = 0x3;
export const ID_DSE = 0x4;
export const ID_PCE = 0x5;
export const ID_FIL = 0x6;
export const ID_END = 0x7;


// AAC profiles
export const AAC_MAIN_PROFILE = 0;
export const AAC_LOW_COMPLEXITY_PROFILE = 1;
export const AAC_SCALABLE_SAMPLING_RATE_PROFILE = 2;
export const AAC_RESERVED_PROFILE = 3;


// Window Sequences
export const ONLY_LONG_SEQUENCE = 0;
export const LONG_START_SEQUENCE = 1;
export const EIGHT_SHORT_SEQUENCE = 2;
export const LONG_STOP_SEQUENCE = 3;

// Noiseless coding tool constants
export const ZERO_HCB = 0;
export const FIRST_PAIR_HCB = 5;
export const ESC_HCB = 11;
export const QUAD_LEN = 4;
export const PAIR_LEN = 2;

export const INTENSITY_HCB2 = 14;
export const INTENSITY_HCB = 15;
export const ESC_FLAG = 16;

// Values of the extension_type data element
export const EXT_FILL = 0b0000;
export const EXT_FILL_DATA = 0b0001;
export const EXT_DYNAMIC_RANGE = 0b1011;
export const EXT_SBR_DATA = 0b1101;
export const EXT_SBR_DATA_CRC = 0b1110;

export const SF_OFFSET = 200;


let scaleFactorLookupTable: number[] | undefined;
export function scaleFactorLookup(n: number) {
  if (scaleFactorLookupTable === undefined) {
    scaleFactorLookupTable = [];
    for (let i = 0; i < 428; i++) {
      scaleFactorLookupTable[i] = Math.pow(2, (i - 200) / 4);
    }
  }

  return scaleFactorLookupTable[n];
}


let inverseQuantizationLookupTable: number[] | undefined;
export function inverseQuantizationLookup(n: number) {
  if (inverseQuantizationLookupTable === undefined) {
    inverseQuantizationLookupTable = [];
    for (let i = 0; i < 8191; i++) {
      inverseQuantizationLookupTable[i] = Math.pow(i, 4 / 3);
    }
  }

  return inverseQuantizationLookupTable[n];
}


export const NOISE_BAND_TYPE = 13;
export const NOISE_PRE = 256;
export const NOISE_PRE_BITS = 9;
export const NOISE_OFFSET = 90;

const tns_tmp2_map_1_3 = [
  0.00000000, -0.43388373,  0.64278758,  0.34202015,
];

const tns_tmp2_map_0_3 = [
  0.00000000, -0.43388373, -0.78183150, -0.97492790,
  0.98480773,  0.86602539,  0.64278758,  0.34202015,
];

const tns_tmp2_map_1_4 = [
  0.00000000, -0.20791170, -0.40673664, -0.58778524,
  0.67369562,  0.52643216,  0.36124167,  0.18374951,
];

const tns_tmp2_map_0_4 = [
   0.00000000, -0.20791170, -0.40673664, -0.58778524,
  -0.74314481, -0.86602539, -0.95105654, -0.99452192,
   0.99573416,  0.96182561,  0.89516330,  0.79801720,
   0.67369562,  0.52643216,  0.36124167,  0.18374951,
];

export const tns_tmp2_map: number[][] = [
  tns_tmp2_map_0_3,
  tns_tmp2_map_0_4,
  tns_tmp2_map_1_3,
  tns_tmp2_map_1_4
];


export const tns_max_bands_1024 = [
  31, 31, 34, 40, 42, 51, 46, 46, 42, 42, 42, 39, 39,
];


export const tns_max_bands_128 = [
  9, 9, 10, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14,
];

